import PersistentConnector from '../../../general/js/persistent-connector';

let callbackName = 'onRecatpchaLoad';

let isLoaded = false;
let onloadQueue = [];

window[callbackName] = () => {
    isLoaded = true;
    onloadQueue.forEach(callback => callback(window.grecaptcha));
};

export function onReady(callback) {
    if (isLoaded) {
        callback(window.grecaptcha);
    } else {
        onloadQueue.push(callback);
    }
}

function insertScript() {
    let script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.onerror = function () {
        connector.recover();
    };
    script.src = `https://www.google.com/recaptcha/api.js?onload=${callbackName}&render=explicit`;
    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(script, s);
}

let connector = new PersistentConnector(insertScript, {name: 'Recaptcha script'});
insertScript();



// WEBPACK FOOTER //
// ./app/components/recaptcha/js/loadRecaptcha.js